var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShieldLocked = function SvgShieldLocked(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "shield_locked_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shield_locked_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 26.714q-.21 0-.387-.032a2.3 2.3 0 0 1-.358-.093q-4.005-1.407-6.318-4.927t-2.312-7.787v-5.63q0-.712.41-1.282t1.059-.826l7.115-2.656q.402-.145.791-.145.39 0 .79.145l7.116 2.656q.65.255 1.06.826.408.57.409 1.282v5.27q0 .502-.368.85-.368.349-.882.33a6.7 6.7 0 0 0-2.266.474q-1.078.432-1.984 1.338a6.5 6.5 0 0 0-1.344 1.969q-.5 1.125-.5 2.437v4.41a.95.95 0 0 1-.396.793 3.2 3.2 0 0 1-.89.473q-.18.062-.357.093-.18.032-.388.032m5.762.16q-.447 0-.767-.319a1.05 1.05 0 0 1-.32-.767v-3.812q0-.438.32-.75.32-.313.767-.313h.163v-1.25q0-.983.687-1.67a2.27 2.27 0 0 1 1.67-.685q.982 0 1.669.686.686.686.686 1.67v1.25h.163q.442 0 .76.312.315.312.315.75v3.812q0 .448-.312.767-.313.32-.763.32zm1.27-5.96h2.5v-1.25q0-.533-.36-.891a1.2 1.2 0 0 0-.89-.36q-.532 0-.891.36-.36.36-.36.89z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShieldLocked);
export default ForwardRef;